/* Write through the text node that is already there rather than replacing it.

   `el.textContent = x` removes the old text node and inserts a new one, which
   Clarity's replay player records as an insert without the matching remove, so
   the element replays holding every value it has ever held: a button reading
   "ADD TO CARTAdding…Added ✓ADD TO CART", a cart badge reading "1234". Editing
   nodeValue emits a characterData mutation instead and replays as one value.
   Same contract as the copy in assets/ajluxe-cart-boost.js; see memory
   ajluxe-clarity-replay-text-duplication-artifact-sep13.

   Deliberately file-scope and deliberately prefixed: this file is a dozen
   sibling IIFEs and every one of them needs it, so it cannot live inside the
   first one. Only REPEATED writes go through it; markup built once at page
   load has nothing to stack against and is left alone. */
function ajSetText(node, value) {
  if (!node) return;
  var first = node.firstChild;
  if (first && first.nodeType === 3 && !first.nextSibling) {
    if (first.nodeValue !== value) first.nodeValue = value;
    return;
  }
  node.textContent = value;
}

(function () {
  var page = document.querySelector('[data-aj-article]');
  if (!page) return;

  var articleRoot = document.getElementById('article-body');
  var rte = articleRoot && articleRoot.querySelector('.article-body__content');
  if (!rte) return;

  /* ── Shared add-to-cart confirmation sheet (2026-08-18) ────────────────────
     Originally built only for the Product Picks module (below). Modules B
     (inline ad-slot cards) and D (sticky bottom bar) added to cart silently --
     a button label change and a header badge increment, nothing else -- with
     no path to checkout. GA4 showed ATC->checkout running 5-13% for three
     straight weeks even on the highest-intent commercial-comparison articles,
     and a live test confirmed Module D gives zero confirmation after a
     successful add. Hoisted here so all three modules share one sheet instance
     instead of building their own. */

  window.ajAtcSheetEl = window.ajAtcSheetEl || null;
  window.ajShowAtcSheet = function (item, cart) {
    if (!window.ajAtcSheetEl) {
      window.ajAtcSheetEl = document.createElement('div');
      window.ajAtcSheetEl.className = 'aj-atc-sheet';
      window.ajAtcSheetEl.setAttribute('role', 'dialog');
      window.ajAtcSheetEl.setAttribute('aria-live', 'polite');
      window.ajAtcSheetEl.setAttribute('aria-label', 'Added to cart');
      document.body.appendChild(window.ajAtcSheetEl);
    }
    var img = item && item.image ? String(item.image).replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
    var money = function (cents) {
      try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (cart && cart.currency) || 'USD' }); }
      catch (e) { return '$' + (cents / 100).toFixed(2); }
    };
    var esc = function (s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
    window.ajAtcSheetEl.innerHTML =
      '<button type="button" class="aj-atc-sheet__close" aria-label="Keep reading">&times;</button>' +
      '<div class="aj-atc-sheet__row">' +
        (img ? '<img class="aj-atc-sheet__img" src="' + esc(img) + '" alt="" width="56" height="56">' : '') +
        '<div class="aj-atc-sheet__text">' +
          '<p class="aj-atc-sheet__added">Added to cart</p>' +
          '<p class="aj-atc-sheet__title">' + esc(item ? item.product_title : '') + '</p>' +
        '</div>' +
      '</div>' +
      '<p class="aj-atc-sheet__meta">' + (cart ? cart.item_count : 1) + ' item' + ((cart && cart.item_count !== 1) ? 's' : '') +
        ' · ' + money(cart ? cart.total_price : 0) + '</p>' +
      '<div class="aj-atc-sheet__actions">' +
        '<a class="aj-atc-sheet__checkout" href="/checkout">Checkout</a>' +
        '<a class="aj-atc-sheet__cart" href="/cart">View cart</a>' +
      '</div>';
    document.documentElement.classList.add('aj-atc-sheet-open');
    setTimeout(function () { window.ajAtcSheetEl.classList.add('is-visible'); }, 20);
    if (window.ajRefreshCartBar) window.ajRefreshCartBar();
    startAtcSheetTimer();
  };
  window.ajHideAtcSheet = function () {
    clearAtcSheetTimer();
    if (!window.ajAtcSheetEl) return;
    window.ajAtcSheetEl.classList.remove('is-visible');
    document.documentElement.classList.remove('aj-atc-sheet-open');
  };

  /* An outside tap used to dismiss this sheet, which on a phone meant a mistimed
     tap while scrolling on to keep reading destroyed the only checkout link on
     screen -- see the cart-bar comment below for the measurement. Now it closes
     only on the explicit x, on Escape, or on its own after ATC_SHEET_MS.
     The timer pauses while the reader is actually on the sheet (pointer over it
     or keyboard focus inside), because the one thing worse than a sheet that
     lingers is one that vanishes under a thumb reaching for Checkout. */
  var ATC_SHEET_MS = 8000;
  var atcSheetTimer = null;
  function clearAtcSheetTimer() {
    if (atcSheetTimer != null) { clearTimeout(atcSheetTimer); atcSheetTimer = null; }
  }
  function startAtcSheetTimer() {
    clearAtcSheetTimer();
    atcSheetTimer = setTimeout(function () { window.ajHideAtcSheet(); }, ATC_SHEET_MS);
  }
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('.aj-atc-sheet__close')) window.ajHideAtcSheet();
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') window.ajHideAtcSheet(); });
  /* Bound on document rather than the sheet element: the sheet is created lazily
     on the first add, so there is nothing to bind to at this point. */
  document.addEventListener('pointerenter', function (ev) {
    if (ev.target.closest && ev.target.closest('.aj-atc-sheet')) clearAtcSheetTimer();
  }, true);
  document.addEventListener('pointerleave', function (ev) {
    if (ev.target.closest && ev.target.closest('.aj-atc-sheet') &&
        window.ajAtcSheetEl && window.ajAtcSheetEl.classList.contains('is-visible')) startAtcSheetTimer();
  }, true);
  document.addEventListener('focusin', function (ev) {
    if (ev.target.closest && ev.target.closest('.aj-atc-sheet')) clearAtcSheetTimer();
  });
  document.addEventListener('focusout', function (ev) {
    if (ev.target.closest && ev.target.closest('.aj-atc-sheet') &&
        window.ajAtcSheetEl && window.ajAtcSheetEl.classList.contains('is-visible')) startAtcSheetTimer();
  });

  /* ── Cart recovery bar (2026-08-30) ────────────────────────────────────────
     The confirmation sheet above is transient: it dismisses on any tap outside
     itself, including a mistimed one while scrolling on to keep reading. That
     was survivable on a product page and is not here -- articles run ~34,000px
     on mobile, the article header is `position: static`, and the theme's
     `.header-sticky` clone that would otherwise carry a cart link is
     `display: none` below 768px. So once the sheet is gone there is no element
     anywhere on screen linking to /cart or /checkout. Measured live 2026-08-30 (querying every /cart and /checkout
     link in the viewport after an add, mid-article: zero), and it shows up in
     the funnel -- blog landings convert ATC->checkout at 15.4% against 42.5%
     on product pages, which are ~5x shorter and so keep the header within
     a flick of the thumb.
     So: one persistent bar, driven purely by real cart state from /cart.js,
     that gives every reader a permanent visible exit to payment. It replaces
     the Module D promo bar while the cart is non-empty (getting to checkout
     beats promoting one more product) via the `aj-has-cart` root class, and
     hides under the confirmation sheet so the two never stack. Rendered
     unconditionally in the liquid -- unlike the promo bar, which needs an
     aj_shop_product -- so a reader who arrives carrying a cart from a previous
     page also gets it back. */
  (function () {
    var bar = document.querySelector('[data-aj-cart-bar]');
    if (!bar) return;
    var imgLink = bar.querySelector('[data-aj-cart-bar-img-link]');
    var img = bar.querySelector('[data-aj-cart-bar-img]');
    var countEl = bar.querySelector('[data-aj-cart-bar-count]');
    var totalEl = bar.querySelector('[data-aj-cart-bar-total]');
    var root = document.documentElement;

    function money(cents, currency) {
      try {
        return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency || 'USD' });
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function render(cart) {
      if (!cart || !cart.item_count) {
        bar.classList.remove('is-visible');
        root.classList.remove('aj-has-cart');
        return;
      }
      var first = cart.items && cart.items[0];
      if (img && first && first.image) {
        img.src = String(first.image).replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
        img.alt = first.product_title || '';
        if (imgLink) imgLink.style.display = '';
      } else if (imgLink) {
        imgLink.style.display = 'none';
      }
      if (countEl) {
        ajSetText(countEl, cart.item_count + (cart.item_count === 1 ? ' item in your cart' : ' items in your cart'));
      }
      ajSetText(totalEl, money(cart.total_price, cart.currency));
      root.classList.add('aj-has-cart');
      bar.classList.add('is-visible');
    }

    window.ajRefreshCartBar = function () {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    };
    window.ajRefreshCartBar();
    /* Shopify serves article HTML from cache and a bfcache restore replays the
       DOM as it was, so a bar built before an add (or after a checkout) comes
       back stale -- re-read the real cart on every restore. */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) window.ajRefreshCartBar();
    });
  })();

  var layoutCache = { docY: 0, h: 0, wh: 0 };
  function refreshArticleLayoutCache() {
    if (!articleRoot) return;
    var sy = window.scrollY || document.documentElement.scrollTop;
    var r = articleRoot.getBoundingClientRect();
    layoutCache.docY = r.top + sy;
    layoutCache.h = articleRoot.offsetHeight;
    layoutCache.wh = window.innerHeight;
  }
  refreshArticleLayoutCache();
  var layoutTimer;
  var layoutRaf = null;
  function scheduleArticleLayoutCache() {
    clearTimeout(layoutTimer);
    layoutTimer = setTimeout(function () {
      if (layoutRaf) return;
      layoutRaf = requestAnimationFrame(function () {
        layoutRaf = null;
        refreshArticleLayoutCache();
      });
    }, 120);
  }
  window.addEventListener('resize', scheduleArticleLayoutCache, { passive: true });
  window.addEventListener('load', refreshArticleLayoutCache, { once: true });
  if (typeof ResizeObserver !== 'undefined' && articleRoot) {
    var layoutRo = new ResizeObserver(scheduleArticleLayoutCache);
    layoutRo.observe(articleRoot);
  }

  var isBackForward = false;
  try {
    var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    isBackForward = !!(navEntry && navEntry.type === 'back_forward');
  } catch (e) {}

  /* Without a hash, keep the top of the article in view. Scroll anchoring + late layout
   * (fonts, images, preloader) often leaves the viewport stuck partway down after refresh. */
  if (!window.location.hash && !isBackForward) {
    window.scrollTo(0, 0);
  }

  /** Reduces CLS: set width/height on RTE images from Shopify URL patterns when the editor omits them. */
  function applyRteImageDimensions() {
    rte.querySelectorAll('img').forEach(function (img) {
      if (img.getAttribute('width') && img.getAttribute('height')) return;
      var src = img.getAttribute('src') || '';
      if (!src) return;
      var w;
      var h;
      var m = src.match(/_(\d{2,4})x(\d{2,4})\./);
      if (m) {
        w = m[1];
        h = m[2];
      } else {
        var mw = src.match(/[?&]width=(\d+)/);
        var mh = src.match(/[?&]height=(\d+)/);
        w = mw && mw[1];
        h = mh && mh[1];
        if (w && !h) h = w;
        if (h && !w) w = h;
      }
      if (w && h) {
        img.setAttribute('width', w);
        img.setAttribute('height', h);
      }
    });
  }
  applyRteImageDimensions();

  /** Smaller downloads: add srcset/sizes for Shopify CDN images in RTE when the editor only outputs a single src. */
  function upgradeResponsiveShopifyRteImages() {
    var candidateWidths = [360, 540, 720, 900];
    rte.querySelectorAll('img').forEach(function (img) {
      if (img.classList.contains('aj-rte-img-responsive')) return;
      var src = img.getAttribute('src') || '';
      if (!src) return;
      if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return;
      var existing = img.getAttribute('srcset') || '';
      if (existing.indexOf(',') !== -1) return;
      function withWidth(u, w) {
        var q = u.indexOf('?');
        if (q === -1) return u + '?width=' + w;
        var base = u.slice(0, q);
        var rest = u.slice(q + 1);
        rest = rest
          .replace(/(^|&)width=\d+/g, '')
          .replace(/(^|&)height=\d+/g, '')
          .replace(/&&/g, '&')
          .replace(/^&|&$/g, '');
        if (rest) return base + '?' + rest + '&width=' + w;
        return base + '?width=' + w;
      }
      var parts = [];
      for (var i = 0; i < candidateWidths.length; i++) {
        var w = candidateWidths[i];
        parts.push(withWidth(src, w) + ' ' + w + 'w');
      }
      img.setAttribute('srcset', parts.join(', '));
      img.setAttribute('sizes', '(max-width: 991px) min(100vw, 720px), 720px');
      img.setAttribute('src', withWidth(src, 720));
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      img.classList.add('aj-rte-img-responsive');
    });
  }
  upgradeResponsiveShopifyRteImages();
  applyRteImageDimensions();

  function scheduleIdle(fn) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: 2500 });
    } else {
      setTimeout(fn, 50);
    }
  }

  function setReadingProgress() {
    var bar = page.querySelector('.article-reading-progress__bar');
    if (!bar || !articleRoot) return;
    var sy = window.scrollY || document.documentElement.scrollTop;
    var start = sy - layoutCache.docY;
    var h = layoutCache.h;
    var wh = layoutCache.wh;
    var end = h - wh;
    var pct = 0;
    if (end > 0) pct = Math.min(100, Math.max(0, (start / end) * 100));
    else if (start > 0) pct = 100;
    page.style.setProperty('--aj-reading-progress', pct + '%');
  }

  var backBtn = document.querySelector('[data-article-top]');
  var toggleBack = null;
  if (backBtn) {
    toggleBack = function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      backBtn.classList.toggle('is-visible', y > 500);
    };
    backBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  var tocMount = document.querySelector('[data-article-toc]');
  var setActiveToc = null;
  if (tocMount) {
    /* The <ul> and each heading's id are rendered server-side now (article-template.liquid)
       so the TOC has its real, final size on first paint -- no post-load DOM build, no CLS.
       This just wires up click-to-scroll and scroll-spy on the markup that's already there. */
    var list = tocMount.querySelector('.aj-toc__list');
    var links = list ? list.querySelectorAll('a') : [];
    if (list && links.length) {
      var headings = [];
      links.forEach(function (a) {
        var href = a.getAttribute('href') || '';
        var h = href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null;
        if (h) headings.push(h);
      });

      links.forEach(function (a) {
        a.addEventListener('click', function (e) {
          var href = a.getAttribute('href');
          if (!href || href.charAt(0) !== '#') return;
          var target = document.getElementById(href.slice(1));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (history.replaceState) history.replaceState(null, '', href);
          }
        });
      });

      var headingDocTops = [];
      var tocOffset = 120;
      function refreshHeadingDocTops() {
        var sy = window.scrollY || document.documentElement.scrollTop;
        headingDocTops = [];
        headings.forEach(function (h) {
          var r = h.getBoundingClientRect();
          headingDocTops.push(r.top + sy);
        });
      }
      refreshHeadingDocTops();
      var resizeTocTimer;
      function scheduleRefreshHeadingDocTops() {
        clearTimeout(resizeTocTimer);
        resizeTocTimer = setTimeout(refreshHeadingDocTops, 120);
      }
      window.addEventListener('resize', scheduleRefreshHeadingDocTops, { passive: true });
      window.addEventListener('load', refreshHeadingDocTops, { once: true });
      rte.addEventListener(
        'load',
        function (e) {
          if (e.target.tagName === 'IMG') scheduleRefreshHeadingDocTops();
        },
        true
      );

      setActiveToc = function () {
        var scrollY = window.scrollY || document.documentElement.scrollTop;
        var activeId = '';
        for (var i = 0; i < headingDocTops.length; i++) {
          if (scrollY >= headingDocTops[i] - tocOffset) activeId = headings[i].id;
        }
        links.forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('href') === '#' + activeId);
        });
      };
    }
  }

  rte.querySelectorAll('table').forEach(function (table) {
    if (table.closest('.table-wrapper')) return;
    var wrap = document.createElement('div');
    wrap.className = 'table-wrapper';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  var imgIndex = 0;
  rte.querySelectorAll('img').forEach(function (img) {
    // Product-card thumbnails (aj-picks-card: end-of-article grid + in-body shoppable cards)
    // must never get the grain-wrap treatment meant for full-width lifestyle photos -- the
    // wrapper's .aj-img-grain img { height:auto } fights the card's own height:100% sizing
    // and left a cream gap under a shrunken thumbnail (found 2026-08-04).
    if (img.closest('.aj-img-grain') || img.closest('.aj-picks-card__img-link')) return;
    var w = document.createElement('span');
    w.className = 'aj-img-grain';
    img.parentNode.insertBefore(w, img);
    w.appendChild(img);
    imgIndex += 1;
    if (imgIndex % 3 === 0) w.classList.add('aj-img-fullbleed');
    if (!img.hasAttribute('loading') && imgIndex > 1) img.setAttribute('loading', 'lazy');
  });

  var inline = document.getElementById('aj-inline-cta');
  if (inline) {
    var host = rte;
    var personalize = null;
    host.querySelectorAll('h2, h3').forEach(function (el) {
      var t = el.textContent || '';
      if (!personalize && /how\s+to\s+personalize|personalize/i.test(t)) personalize = el;
    });
    if (personalize) {
      personalize.insertAdjacentElement('afterend', inline);
      inline.removeAttribute('hidden');
    } else {
      var firstH2 = host.querySelector('h2');
      if (firstH2) firstH2.insertAdjacentElement('afterend', inline);
      else host.insertBefore(inline, host.firstChild);
      inline.removeAttribute('hidden');
    }
  }

  function isFaqSectionTitle(el) {
    var t = (el.textContent || '').trim();
    return /frequently asked/i.test(t) || /\bfaq\b/i.test(t);
  }

  var faqHeading = null;
  rte.querySelectorAll('h2').forEach(function (h2) {
    if (isFaqSectionTitle(h2)) faqHeading = h2;
  });
  if (!faqHeading) {
    rte.querySelectorAll('h3').forEach(function (h3) {
      if (isFaqSectionTitle(h3)) faqHeading = h3;
    });
  }
  if (!faqHeading && rte.querySelector('#faq')) {
    var elFaq = rte.querySelector('#faq');
    if (elFaq && (elFaq.tagName === 'H2' || elFaq.tagName === 'H3')) faqHeading = elFaq;
  }

  if (faqHeading) {
    scheduleIdle(function () {
      var acc = document.createElement('div');
    acc.className = 'faq-accordion';
    var n = faqHeading.nextElementSibling;
    while (n && n.tagName !== 'H2') {
      var next = n.nextElementSibling;
      if (n.tagName === 'H3') {
        var pAfterH3 = n.nextElementSibling;
        if (pAfterH3 && pAfterH3.tagName === 'P') {
          var afterPair = pAfterH3.nextElementSibling;
          var itemH = document.createElement('div');
          itemH.className = 'faq-item';
          var btnH = document.createElement('button');
          btnH.type = 'button';
          btnH.className = 'faq-question';
          btnH.setAttribute('aria-expanded', 'false');
          var spanQh = document.createElement('span');
          spanQh.textContent = (n.textContent || '').trim();
          var iconH = document.createElement('span');
          iconH.className = 'faq-icon';
          iconH.setAttribute('aria-hidden', 'true');
          iconH.textContent = '+';
          btnH.appendChild(spanQh);
          btnH.appendChild(iconH);
          var ansWrapH = document.createElement('div');
          ansWrapH.className = 'faq-answer';
          ansWrapH.appendChild(pAfterH3.cloneNode(true));
          itemH.appendChild(btnH);
          itemH.appendChild(ansWrapH);
          acc.appendChild(itemH);
          n.remove();
          pAfterH3.remove();
          n = afterPair;
          continue;
        }
        acc.appendChild(n);
      } else if (n.tagName === 'P') {
        var strong = n.querySelector(':scope > strong:first-child');
        if (strong) {
          var item = document.createElement('div');
          item.className = 'faq-item';
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'faq-question';
          btn.setAttribute('aria-expanded', 'false');
          var spanQ = document.createElement('span');
          spanQ.textContent = strong.textContent.trim();
          var icon = document.createElement('span');
          icon.className = 'faq-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '+';
          btn.appendChild(spanQ);
          btn.appendChild(icon);
          var ansWrap = document.createElement('div');
          ansWrap.className = 'faq-answer';
          var p = document.createElement('p');
          var clone = n.cloneNode(true);
          var fs = clone.querySelector('strong');
          if (fs) fs.remove();
          p.innerHTML = clone.innerHTML.trim();
          ansWrap.appendChild(p);
          item.appendChild(btn);
          item.appendChild(ansWrap);
          acc.appendChild(item);
          n.remove();
        } else {
          acc.appendChild(n);
        }
      } else if (n.tagName === 'DL') {
        // Some articles write FAQ content as <dl><dt>Q</dt><dd>A</dd>...</dl> instead of the
        // <h3>+<p> or <p><strong>Q</strong>A</p> shapes handled above -- neither branch matched
        // it, so it fell into the plain-append case below and rendered as an inert list with no
        // accordion behaviour (caught 2026-08-01 on best-huggie-earrings). Convert each dt/dd
        // pair into a real .faq-item so it gets the same accordion treatment as every other FAQ.
        var dlChildren = Array.prototype.slice.call(n.children);
        for (var di = 0; di < dlChildren.length; di++) {
          var dtEl = dlChildren[di];
          if (!dtEl || dtEl.tagName !== 'DT') continue;
          var ddEl = dlChildren[di + 1] && dlChildren[di + 1].tagName === 'DD' ? dlChildren[di + 1] : null;
          var itemD = document.createElement('div');
          itemD.className = 'faq-item';
          var btnD = document.createElement('button');
          btnD.type = 'button';
          btnD.className = 'faq-question';
          btnD.setAttribute('aria-expanded', 'false');
          var spanQd = document.createElement('span');
          spanQd.textContent = (dtEl.textContent || '').trim();
          var iconD = document.createElement('span');
          iconD.className = 'faq-icon';
          iconD.setAttribute('aria-hidden', 'true');
          iconD.textContent = '+';
          btnD.appendChild(spanQd);
          btnD.appendChild(iconD);
          var ansWrapD = document.createElement('div');
          ansWrapD.className = 'faq-answer';
          if (ddEl) {
            var pD = document.createElement('p');
            pD.innerHTML = ddEl.innerHTML;
            ansWrapD.appendChild(pD);
          }
          itemD.appendChild(btnD);
          itemD.appendChild(ansWrapD);
          acc.appendChild(itemD);
        }
        n.remove();
      } else {
        acc.appendChild(n);
      }
      n = next;
    }
    if (acc.children.length) faqHeading.insertAdjacentElement('afterend', acc);

    acc.querySelectorAll('.faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var isOpen = item.classList.contains('open');
        acc.querySelectorAll('.faq-item').forEach(function (i) {
          i.classList.remove('open');
        });
        acc.querySelectorAll('.faq-question').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
  }

  var sticky = document.querySelector('[data-aj-sticky-cta]');
  var onScrollSticky = null;
  if (sticky) {
    var dismissed = sessionStorage.getItem('aj-sticky-cta-dismissed') === '1';
    var shown = false;
    onScrollSticky = function () {
      if (dismissed || shown) return;
      var y = window.scrollY || document.documentElement.scrollTop;
      var h = Math.max(1, layoutCache.h);
      var scrolledInto = Math.max(0, y - layoutCache.docY);
      var cro = document.documentElement.classList.contains('aj-cro');
      // `scrolledInto` only starts counting past the article body top, which on
      // a long guide is already ~2.7 screens down — so a ratio can never fire
      // early enough. Measure raw scroll instead: a reader who has moved just
      // over one screen is engaged, and is exactly who the bar is for.
      var hit = cro
        ? (y >= layoutCache.wh * 1.2)
        : (scrolledInto / h >= 0.3);
      if (hit) {
        sticky.classList.add('is-visible');
        shown = true;
      }
    };
    var dismissBtn = sticky.querySelector('[data-aj-sticky-dismiss]');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        sticky.classList.add('is-dismissed');
        sticky.classList.remove('is-visible');
        sessionStorage.setItem('aj-sticky-cta-dismissed', '1');
        dismissed = true;
      });
    }
  }

  /* Sticky article header, reveal on scroll up. See blog-article.css for why
     this is `position: fixed` + a measured spacer and not `position: sticky`.
     The spacer height is published as `--aj-hdr-h` instead of hardcoding 56px,
     so an announcement bar or a wrapped logo can't end up overlapping the
     first paragraph. */
  var headerEl = document.querySelector('header.header');
  var updateStickyHeader = null;
  if (headerEl) {
    var setHeaderSpacer = function () {
      var h = headerEl.offsetHeight;
      if (h) document.documentElement.style.setProperty('--aj-hdr-h', h + 'px');
    };
    setHeaderSpacer();
    window.addEventListener('load', setHeaderSpacer, { once: true });
    window.addEventListener('resize', setHeaderSpacer, { passive: true });

    var lastHeaderY = window.scrollY || document.documentElement.scrollTop || 0;
    updateStickyHeader = function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      var delta = y - lastHeaderY;
      if (Math.abs(delta) < 6) return;   // ignore sub-pixel/rubber-band jitter
      // Never hide it in the first couple of header-heights: at the top of the
      // article the header is part of the page, not a floating bar.
      var past = y > headerEl.offsetHeight * 2;
      document.body.classList.toggle('aj-hdr-hidden', past && delta > 0);
      lastHeaderY = y;
    };
  }

  var scrollRaf = null;
  function flushScroll() {
    scrollRaf = null;
    setReadingProgress();
    if (toggleBack) toggleBack();
    if (setActiveToc) setActiveToc();
    if (onScrollSticky) onScrollSticky();
    if (updateStickyHeader) updateStickyHeader();
  }
  function scheduleScroll() {
    if (scrollRaf != null) return;
    scrollRaf = requestAnimationFrame(flushScroll);
  }
  refreshArticleLayoutCache();
  window.addEventListener('scroll', scheduleScroll, { passive: true });
  flushScroll();

  if (!window.location.hash && !isBackForward) {
    function pinArticleTop() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo(0, 0);
        });
      });
    }
    if (document.readyState === 'complete') {
      pinArticleTop();
    } else {
      window.addEventListener('load', pinArticleTop, { once: true });
    }
  }
})();

  /* CRO: relocate the welcome-offer capture from end-of-content to just after
     the second H2. At end-of-content it sat ~15 screens down on a long guide —
     past the point most readers leave. */
  (function () {
    if (!document.documentElement.classList.contains('aj-cro') &&
        !document.documentElement.classList.contains('aj-cap')) return;
    var cap = document.querySelector('[data-aj-capture]');
    var rte = document.querySelector('.article-body__content');
    if (!cap || !rte) return;
    var heads = rte.querySelectorAll('h2');
    if (heads.length < 2) return;
    var target = heads[1];
    // Insert before the 2nd H2 so the module never splits a section.
    target.parentNode.insertBefore(cap, target);
  })();

  /* ── CRO: capture submit → Shopify customer + Omnisend contact ────────────
     Dual-write on purpose. The Shopify form creates the customer record (so
     the person exists in Admin > Customers and syncs with the store), and the
     Omnisend SDK writes the marketing contact with the tags the automations
     key off. The SDK is the queue Omnisend's own snippet installs, so no API
     key is ever exposed to the browser.

     Formerly also collected birth month/day to time a birthday automation;
     dropped 2026-08-25 (see article-template.liquid) since almost nobody
     filled the date in.

     Tag contract — automations depend on these exact strings:
       source:article            every capture from a blog article
       capture:welcome-offer     this module (vs a generic newsletter box)
       article:<handle>          which article earned the contact
       intent:informational      set when the article is a definition lookup
  */
  (function () {
    if (!document.documentElement.classList.contains('aj-cro') &&
        !document.documentElement.classList.contains('aj-cap')) return;
    var form = document.querySelector('.aj-capture__form');
    if (!form) return;

    var wrap = form.closest('[data-aj-capture]');
    var handle = (wrap && wrap.getAttribute('data-article-handle')) || '';
    var intent = (wrap && wrap.getAttribute('data-article-intent')) || '';

    function setMsg(cls, text) {
      var old = form.querySelector('.aj-capture__ok, .aj-capture__err');
      if (old) old.remove();
      var p = document.createElement('p');
      p.className = cls;
      p.setAttribute('role', cls === 'aj-capture__ok' ? 'status' : 'alert');
      ajSetText(p, text);
      form.appendChild(p);
    }

    // Capture phase + stopImmediatePropagation: GTM and the Omnisend form
    // script both bind submit handlers here, and a native re-submit from
    // either one navigates away mid-request.
    /* MUST submit natively. Shopify only attaches its CAPTCHA token to customer forms
       on a real form submission; a fetch() POST arrives without one and Shopify answers
       400 "Missing CAPTCHA token". Both handlers here used to preventDefault, fetch, and
       never check res.ok -- so they rendered "your code is on its way" on top of the
       rejection. The form reported success and wrote nothing, on every article, for as
       long as it has been live (verified 2026-08-30: 0 customers and 0 Omnisend contacts
       ever carried these tags). Do not reintroduce preventDefault without also solving
       the CAPTCHA token. */
    form.addEventListener('submit', function (ev) {
      var email = (form.querySelector('input[type=email]') || {}).value;
      if (!email) { ev.preventDefault(); setMsg('aj-capture__err', 'Please enter an email address.'); return; }

      var btn = form.querySelector('.aj-capture__btn');
      // Do NOT disable the submit button here. A disabled submitter cancels the native
      // submit outright, which is exactly how this form silently stopped working once the
      // fetch() was removed. Relabel on the next tick, after the browser has committed.
      if (btn) { setTimeout(function () { ajSetText(btn, 'Sending…'); }, 0); }

      var tags = ['source:article', 'capture:welcome-offer'];
      if (handle) tags.push('article:' + handle);
      if (intent) tags.push('intent:' + intent);

      var contact = { email: email, tags: tags, source: 'article-welcome-offer-capture' };

      try {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['identifyContact', contact]);
        window.omnisend.push(['track', '$subscribed', { email: email }]);
      } catch (e) { /* Omnisend must never block the Shopify write */ }

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'aj_cro_click', module: 'C', variant: 'welcome-offer-capture',
          article_handle: handle || '' });
      } catch (e) {}
      // Falls through to the browser's own submit. Shopify validates the CAPTCHA, creates
      // the customer, and redirects back with ?customer_posted=true, which the Liquid
      // already renders a success message for via form.posted_successfully?.
    }, true);
  })();

  /* ── CRO click tracking (added 2026-07-31, cro-v2 batch) ──────────────────
     One delegated listener for every theme-rendered CRO element that ISN'T the
     welcome-offer capture form above (that one fires its own event on confirmed
     success, not just a click, since it's the only module with a real
     server round-trip to wait on). Everything here is a plain click/nav —
     GTM/GA4-compatible dataLayer push, same event name and shape so all CRO
     interactions land in one place for analysis regardless of module.
     Module-authored blocks (trust strip, option picker — written directly
     into body_html by apply_new_article.py) fire the same event via their
     own inline onclick, since those elements don't exist until the model
     writes them and aren't queryable by a fixed selector here. */
  document.addEventListener('click', function (ev) {
    // .aj-sticky-cta__btn is deliberately NOT in this list -- since 2026-08-01 it does a real
    // /cart/add.js POST (Module D rebuild below) and pushes its own aj_cro_click/aj_cart_add
    // pair on success, same as the ad-slot handler. Including it here would double-fire.
    var el = ev.target.closest(
      '.aj-inline-cta__btn, .aj-shop-card__form button[type="submit"], .aj-picks-card__cta, ' +
      '.aj-ad-slot__img-link, .aj-ad-slot__title a, .aj-ad-slot__details, .aj-sticky-cta__details'
    );
    if (!el) return;
    var module = el.closest('[data-aj-sticky-cta]') ? 'D'
      : el.classList.contains('aj-inline-cta__btn') ? 'B'
      : el.closest('.aj-shop-card') ? 'B'
      : 'B';
    var variant = el.classList.contains('aj-picks-card__cta') ? 'product-picks'
      : el.closest('[data-aj-sticky-cta]') ? 'sticky-bar-details'
      : el.classList.contains('aj-inline-cta__btn') ? 'inline-cta'
      : el.closest('.aj-ad-slot') ? 'inline-ad-slot-pdp'
      : 'sidebar-shop-card';
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'aj_cro_click', module: module, variant: variant,
        article_handle: (document.querySelector('[data-aj-capture]') || {}).dataset
          ? document.querySelector('[data-aj-capture]').dataset.articleHandle : '' });
    } catch (e) {}
  }, true);

  /* ── CRO Module B: inline shoppable ad-slot hydration ──────────────────────
     Gated on `aj-cro` (cro-v2 tag or AJ_CRO_LIVE), same as modules A/D/E --
     this is the "own ads" unit, distinct from the aj-cap-only birthday
     capture. The writer places <div class="aj-ad-slot" data-aj-ad-slot
     data-topic="X"></div> markers directly in article.content, one per H2,
     after that section's first paragraph, max 4. article-template.liquid
     emits the matching product data in #aj-ad-slot-data, keyed by topic,
     resolved fresh from all_products at render time so price/availability
     are never stale and never hardcoded into body_html. A marker with no
     live/in-stock match for its topic is removed rather than left visible
     and broken -- see docs/plans/AUG2026_ADS_AND_NEXT_20_PLAN.md §4.7. */
  (function () {
    if (!document.documentElement.classList.contains('aj-cro')) return;
    var markers = document.querySelectorAll('[data-aj-ad-slot]');
    if (!markers.length) return;
    var dataEl = document.getElementById('aj-ad-slot-data');
    var slots = {};
    if (dataEl) {
      try { slots = JSON.parse(dataEl.textContent || dataEl.innerHTML) || {}; } catch (e) { slots = {}; }
    }
    var esc = function (s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    };
    // Tagged so GA4/Shopify order attribution (both already read utm_* params -- see
    // shopify_funnel_by_referrer / segment_monthly) can tell an ad-slot click apart from any
    // other path to the same PDP, and which element of the card (photo / title / details link)
    // and which topic sent it -- not just "came from this article".
    var capEl = document.querySelector('[data-aj-capture]');
    var articleHandle = capEl ? capEl.dataset.articleHandle : '';
    var trackUrl = function (url, topic, part) {
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('utm_source', 'blog');
        u.searchParams.set('utm_medium', 'ad-slot');
        u.searchParams.set('utm_campaign', articleHandle || '');
        u.searchParams.set('utm_content', (topic || '') + '-' + part);
        return u.pathname + u.search;
      } catch (e) { return url; }
    };
    var rendered = 0;
    markers.forEach(function (marker) {
      var topic = marker.getAttribute('data-topic') || '';
      var s = slots[topic];
      if (!s || rendered >= 4) { marker.remove(); return; }
      rendered++;
      var urlPhoto = trackUrl(s.url, topic, 'photo');
      var urlTitle = trackUrl(s.url, topic, 'title');
      var urlDetails = trackUrl(s.url, topic, 'details');
      marker.innerHTML =
        '<a class="aj-ad-slot__img-link" href="' + esc(urlPhoto) + '" aria-label="' + esc(s.title) + '">' +
          (s.image ? '<img src="' + esc(s.image) + '" alt="' + esc(s.imageAlt) + '" width="128" height="128" loading="lazy" decoding="async">' : '') +
        '</a>' +
        '<div class="aj-ad-slot__body">' +
          (s.bestFor ? '<p class="aj-ad-slot__eyebrow">' + esc(s.bestFor) + '</p>' : '') +
          '<p class="aj-ad-slot__title"><a href="' + esc(urlTitle) + '">' + esc(s.title) + '</a></p>' +
          (s.rationale ? '<p class="aj-ad-slot__rationale">' + esc(s.rationale) + '</p>' : '') +
          '<div class="aj-ad-slot__row">' +
            '<span class="aj-ad-slot__price">' +
              (s.comparePrice ? '<span class="aj-ad-slot__compare">' + esc(s.comparePrice) + '</span>' : '') +
              esc(s.price) +
            '</span>' +
            '<a class="aj-ad-slot__details" href="' + esc(urlDetails) + '">Full details</a>' +
            (s.variantId
              ? '<button type="button" class="aj-ad-slot__add" data-aj-adslot-add ' +
                'data-variant-id="' + esc(s.variantId) + '" data-topic="' + esc(topic) + '" data-handle="' + esc(s.handle) + '">' +
                'Add to cart</button>'
              : '<a class="aj-ad-slot__add aj-ad-slot__choose" href="' + esc(urlDetails) + '">Choose Options</a>') +
          '</div>' +
        '</div>';
      marker.classList.add('aj-ad-slot');
      marker.removeAttribute('data-aj-ad-slot');
    });
  })();

  /* ── CRO Module B: add-to-cart for the inline ad slot ──────────────────────
     Real /cart/add.js POST, no navigation, no drawer takeover (per the design
     spec). Updates the header bag count in place via the theme's own
     [data-cart-count] element (snippets/header-cart.liquid) -- deliberately
     NOT guessing at this theme's proprietary cart-drawer refresh event. */
  (function () {
    if (!document.documentElement.classList.contains('aj-cro')) return;
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-aj-adslot-add]');
      if (!btn || btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || variantId === 'null') return;
      var original = btn.textContent;
      btn.disabled = true;
      ajSetText(btn, 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { return Promise.reject(e); });
        return r.json();
      }).then(function (added) {
        ajSetText(btn, 'Added ✓');
        btn.classList.add('is-added');
        var item = (added && added.items && added.items[0]) || added;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            ajSetText(el, cart.item_count);
          });
          window.ajShowAtcSheet(item, cart);
        }).catch(function () { window.ajShowAtcSheet(item, null); });
        try {
          window.dataLayer = window.dataLayer || [];
          var capEl = document.querySelector('[data-aj-capture]');
          var handle = capEl ? capEl.dataset.articleHandle : '';
          window.dataLayer.push({ event: 'aj_cro_click', module: 'B', variant: 'inline-ad-slot',
            article_handle: handle || '' });
          window.dataLayer.push({ event: 'aj_cart_add', module: 'B',
            slot_topic: btn.getAttribute('data-topic') || '',
            product_handle: btn.getAttribute('data-handle') || '', article_handle: handle || '' });
        } catch (e) {}
        setTimeout(function () {
          btn.disabled = false;
          ajSetText(btn, original);
          btn.classList.remove('is-added');
        }, 2500);
      }).catch(function (err) {
        /* "Try again" was the only thing a shopper ever saw here, whatever went wrong.
           Shopify's own message is the useful part and was being thrown away. The two
           real cases on this catalogue:
             - "...is already sold out."
             - "The maximum quantity of this item is already in your cart."
           The second one is not an error at all from the shopper's side: the piece IS in
           their bag, and "Try again" tells them the site is broken. Both now say what
           happened, and the already-in-bag case points at the bag instead. */
        btn.disabled = false;
        var raw = (err && (err.description || err.message)) || '';
        var already = /maximum quantity/i.test(raw);
        var soldOut = /sold out/i.test(raw);
        ajSetText(btn, already ? 'Already in your bag'
                   : soldOut ? 'Sold out'
                   : 'Try again');
        /* Sold out is not transient: leave it said rather than flipping back to an
           invitation to retry something that cannot succeed. */
        if (!soldOut) {
          setTimeout(function () { ajSetText(btn, original); }, already ? 3000 : 2000);
        }
        if (already) {
          /* Resync the header badge: the piece really is in the bag, so the count the
             shopper can see must agree with the message they were just given.
             Deliberately NOT calling ajShowAtcSheet here. It self-guards and does not
             open on this path, and its dialog is labelled "Added to cart", which is the
             one thing that did not just happen. */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              ajSetText(el, cart.item_count);
            });
          }).catch(function () {});
        }
      });
    }, true);
  })();

  /* ── Product picks: real add-to-cart (added 2026-08-07) ───────────────────
     Same /cart/add.js shape as the Module B ad-slot handler above, with one
     deliberate difference: this one is NOT gated on `aj-cro`. The ad slots are
     a per-article cro-v2 experiment; snippets/article-product-picks.liquid
     renders on every article, and the whole point of this change is that the
     0.18% add-to-cart rate is a sitewide problem, not a 20-article one.

     Covers both surfaces the snippet renders -- the end-of-article grid
     (server-rendered Liquid) and the mid-article strip (built client-side by
     the snippet's own inline script) -- because a delegated listener on
     document catches the strip's buttons whenever they get injected.

     `.aj-picks-card__cta` deliberately keeps its place in the aj_cro_click
     tracker above: that class now only ever renders on the "Choose Options"
     link, which really is a navigation. The add-to-cart button is a different
     class and pushes its own event pair here, so nothing double-fires. */
  (function () {
    function articleHandle() {
      var capEl = document.querySelector('[data-aj-capture]');
      if (capEl && capEl.dataset.articleHandle) return capEl.dataset.articleHandle;
      var m = location.pathname.match(/\/blogs\/[^/]+\/([^/?#]+)/);
      return m ? m[1] : '';
    }

    /* Confirmation sheet: shared ajShowAtcSheet/ajHideAtcSheet, hoisted to the
       top of this file 2026-08-18 so Module B and Module D can use the same
       sheet Product Picks introduced 2026-08-07. See that block for why it's a
       custom sheet and not the theme's cart drawer. */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-aj-picks-add]');
      if (!btn || btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || variantId === 'null') return;
      var original = btn.textContent;
      var handle = articleHandle();
      var slot = btn.getAttribute('data-slot') || 'product-picks';
      btn.disabled = true;
      ajSetText(btn, 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        /* Underscore-prefixed line-item properties: hidden from the customer, but
           they ride the line all the way into the ORDER. That is the only
           attribution here that survives to a purchase -- GA4 can tell us what got
           added, only this can tell us what article and placement earned revenue
           (read back later from shopify_order_line.properties). */
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1,
          properties: { '_aj_article': handle, '_aj_placement': slot } }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { return Promise.reject(e); });
        return r.json();
      }).then(function (added) {
        ajSetText(btn, 'Added ✓');
        btn.classList.add('is-added');
        var item = (added && added.items && added.items[0]) || added;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            ajSetText(el, cart.item_count);
          });
          window.ajShowAtcSheet(item, cart);
        }).catch(function () { window.ajShowAtcSheet(item, null); });
        try {
          /* dataLayer kept for the day a GTM container exists -- as of 2026-08-07
             there is none on this store, so these pushes are inert on their own.
             gtag() is the path that actually reaches Google today (Google tag
             GT-NGK4L2P5 / AW-11278991347 are live sitewide). Fire both. */
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'aj_cro_click', module: 'B', variant: slot, article_handle: handle });
          window.dataLayer.push({ event: 'aj_cart_add', module: 'B', slot_topic: slot,
            product_handle: btn.getAttribute('data-handle') || '', article_handle: handle });
          if (typeof window.gtag === 'function') {
            var price = item && item.price ? item.price / 100 : undefined;
            /* Shopify's own web pixel already emits the standard add_to_cart
               (shopify_event_name: product_added_to_cart, routed to GA4 G-H8DRXSQ9P5 and
               AW-11278991347). Emitting our own here double-counted it in GA4 -- and ours
               carried the product HANDLE as item_id against Shopify's shopify_US_<p>_<v>,
               so the two never even reconciled. Removed 2026-08-31; aj_cart_add below keeps
               the article/placement attribution, which is the only part Shopify's event lacks. */
            gtag('event', 'aj_cart_add', {
              aj_article: handle, aj_placement: slot,
              aj_product: btn.getAttribute('data-handle') || '', value: price, currency: 'USD'
            });
          }
        } catch (e) {}
        setTimeout(function () {
          btn.disabled = false;
          ajSetText(btn, original);
          btn.classList.remove('is-added');
        }, 2500);
      }).catch(function (err) {
        /* "Try again" was the only thing a shopper ever saw here, whatever went wrong.
           Shopify's own message is the useful part and was being thrown away. The two
           real cases on this catalogue:
             - "...is already sold out."
             - "The maximum quantity of this item is already in your cart."
           The second one is not an error at all from the shopper's side: the piece IS in
           their bag, and "Try again" tells them the site is broken. Both now say what
           happened, and the already-in-bag case points at the bag instead. */
        btn.disabled = false;
        var raw = (err && (err.description || err.message)) || '';
        var already = /maximum quantity/i.test(raw);
        var soldOut = /sold out/i.test(raw);
        ajSetText(btn, already ? 'Already in your bag'
                   : soldOut ? 'Sold out'
                   : 'Try again');
        /* Sold out is not transient: leave it said rather than flipping back to an
           invitation to retry something that cannot succeed. */
        if (!soldOut) {
          setTimeout(function () { ajSetText(btn, original); }, already ? 3000 : 2000);
        }
        if (already) {
          /* Resync the header badge: the piece really is in the bag, so the count the
             shopper can see must agree with the message they were just given.
             Deliberately NOT calling ajShowAtcSheet here. It self-guards and does not
             open on this path, and its dialog is labelled "Added to cart", which is the
             one thing that did not just happen. */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              ajSetText(el, cart.item_count);
            });
          }).catch(function () {});
        }
      });
    }, true);
  })();

  /* ── Sidebar "Shop This Look" card: real add-to-cart (added 2026-08-29) ────
     Was the only ATC surface left doing a native {% form 'product' %} POST --
     a full navigation straight to /cart with no confirmation, unlike every
     other module on the page. Same /cart/add.js shape + shared confirmation
     sheet as Module B / Product Picks above. Only ever renders when the
     product is single-variant (see article-template.liquid) -- multi-variant
     products render a "Choose Options" link instead, so there's no
     variant-choice case to handle here. `aj_cro_click` for this element is
     already pushed by the delegated click tracker earlier in this file
     (`.aj-shop-card__form button[type="submit"]`), so only aj_cart_add fires
     here -- pushing both would double-count. */
  (function () {
    function articleHandle() {
      var capEl = document.querySelector('[data-aj-capture]');
      if (capEl && capEl.dataset.articleHandle) return capEl.dataset.articleHandle;
      var m = location.pathname.match(/\/blogs\/[^/]+\/([^/?#]+)/);
      return m ? m[1] : '';
    }
    document.addEventListener('submit', function (ev) {
      var form = ev.target.closest('.aj-shop-card__form');
      if (!form) return;
      ev.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('button[type="submit"]');
      var variantId = idInput ? idInput.value : null;
      if (!btn || btn.disabled || !variantId) return;
      var original = btn.textContent;
      var handle = articleHandle();
      var card = form.closest('.aj-shop-card');
      var productHandle = card ? (card.getAttribute('data-handle') || '') : '';
      var productTitle = card ? (card.querySelector('.aj-shop-card__title') || {}).textContent : '';
      btn.disabled = true;
      ajSetText(btn, 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1,
          properties: { '_aj_article': handle, '_aj_placement': 'sidebar-shop-card' } }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { return Promise.reject(e); });
        return r.json();
      }).then(function (added) {
        ajSetText(btn, 'Added ✓');
        var item = (added && added.items && added.items[0]) || added;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            ajSetText(el, cart.item_count);
          });
          window.ajShowAtcSheet(item, cart);
        }).catch(function () { window.ajShowAtcSheet(item, null); });
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'aj_cart_add', module: 'B', slot_topic: 'sidebar-shop-card',
            product_handle: productHandle, article_handle: handle });
          if (typeof window.gtag === 'function') {
            var price = item && item.price ? item.price / 100 : undefined;
            /* Shopify's own web pixel already emits the standard add_to_cart
               (shopify_event_name: product_added_to_cart, routed to GA4 G-H8DRXSQ9P5 and
               AW-11278991347). Emitting our own here double-counted it in GA4 -- and ours
               carried the product HANDLE as item_id against Shopify's shopify_US_<p>_<v>,
               so the two never even reconciled. Removed 2026-08-31; aj_cart_add below keeps
               the article/placement attribution, which is the only part Shopify's event lacks. */
            gtag('event', 'aj_cart_add', {
              aj_article: handle, aj_placement: 'sidebar-shop-card',
              aj_product: productHandle, value: price, currency: 'USD'
            });
          }
        } catch (e) {}
        setTimeout(function () {
          btn.disabled = false;
          ajSetText(btn, original);
        }, 2500);
      }).catch(function (err) {
        /* "Try again" was the only thing a shopper ever saw here, whatever went wrong.
           Shopify's own message is the useful part and was being thrown away. The two
           real cases on this catalogue:
             - "...is already sold out."
             - "The maximum quantity of this item is already in your cart."
           The second one is not an error at all from the shopper's side: the piece IS in
           their bag, and "Try again" tells them the site is broken. Both now say what
           happened, and the already-in-bag case points at the bag instead. */
        btn.disabled = false;
        var raw = (err && (err.description || err.message)) || '';
        var already = /maximum quantity/i.test(raw);
        var soldOut = /sold out/i.test(raw);
        ajSetText(btn, already ? 'Already in your bag'
                   : soldOut ? 'Sold out'
                   : 'Try again');
        /* Sold out is not transient: leave it said rather than flipping back to an
           invitation to retry something that cannot succeed. */
        if (!soldOut) {
          setTimeout(function () { ajSetText(btn, original); }, already ? 3000 : 2000);
        }
        if (already) {
          /* Resync the header badge: the piece really is in the bag, so the count the
             shopper can see must agree with the message they were just given.
             Deliberately NOT calling ajShowAtcSheet here. It self-guards and does not
             open on this path, and its dialog is labelled "Added to cart", which is the
             one thing that did not just happen. */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              ajSetText(el, cart.item_count);
            });
          }).catch(function () {});
        }
      });
    }, true);
  })();

  /* ── Sold-out inline product links (added 2026-09-10) ─────────────────────
     39 articles link to products that later sold out. The PDP handles it properly
     (it hides Add to Cart and shows "Notify me when available"), but the reader has
     no way to know before clicking, and Clarity shows these shoppers bouncing back
     out to a collection and drifting off.

     DECORATE, DO NOT REDIRECT. The anchor text names the product ("Shop the Micro
     Pave CZ Huggie Hoops"), and silently repointing the href at a different product
     is the CTA-mismatch bug this codebase has shipped twice before. The sentence
     stays true; a live alternative is offered beside it.

     Fully automatic in BOTH directions: nothing is written into the article body, so
     a restocked product simply stops being annotated on the next page view. No content
     edit to make, and none to undo.

     One request per unique PRODUCT, not per link, resolved on idle. An earlier version
     used an IntersectionObserver per link, which is lazier but only fires once the page
     actually paints, so it silently did nothing in a backgrounded or non-painting tab.
     A typical article carries ~10 unique products, cached for the session, so the
     deterministic version costs little and always runs. */
  (function () {
    var body = document.querySelector('.article-body__content');
    if (!body || !window.fetch) return;

    /* product.type -> the collection a reader should land on instead. Anything not
       listed falls back to the full catalogue rather than guessing a handle that may
       not exist. */
    var TYPE_COLLECTION = {
      'Earrings': 'earrings',
      'Necklaces': 'necklaces',
      'Rings': 'rings',
      'Bracelets': 'bracelets',
      'Anklets': 'anklets'
    };

    function cached(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    }
    function remember(key, value) {
      try { sessionStorage.setItem(key, value); } catch (e) {}
    }

    function decorate(link, type) {
      if (link.dataset.ajOos) return;
      link.dataset.ajOos = '1';
      link.classList.add('aj-oos-link');
      var slug = TYPE_COLLECTION[type];
      var alt = document.createElement('a');
      alt.className = 'aj-oos-alt';
      alt.href = slug ? '/collections/' + slug : '/collections/all';
      alt.textContent = slug ? 'sold out, see similar' : 'sold out, browse all';
      link.insertAdjacentText('afterend', ' ');
      link.insertAdjacentElement('afterend', alt);
    }

    function run() {
      var byHandle = {};
      body.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (!m) return;
        (byHandle[m[1]] = byHandle[m[1]] || []).push(a);
      });
      Object.keys(byHandle).forEach(function (handle) {
        var links = byHandle[handle];
        var hit = cached('aj_avail_' + handle);
        if (hit === '1') return;
        if (hit === '0') {
          var t = cached('aj_type_' + handle) || '';
          links.forEach(function (l) { decorate(l, t); });
          return;
        }
        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            remember('aj_avail_' + handle, p.available ? '1' : '0');
            if (p.available) return;
            remember('aj_type_' + handle, p.type || '');
            links.forEach(function (l) { decorate(l, p.type); });
          })
          .catch(function () {});
      });
    }

    if (window.requestIdleCallback) {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 1200);
    }
  })();

  /* ── Signup attribution event (added 2026-08-07) ──────────────────────────
     The capture forms are real Shopify {% form 'customer' %} POSTs, so the page
     reloads and any submit-time event is lost in the navigation. Instead the
     success paragraph is server-rendered only when form.posted_successfully? is
     true, carrying its own placement + country -- so its presence on load IS the
     conversion signal. Shopify customer tags (blog-<handle>, capture:<placement>,
     country:<iso>) remain the durable record; this is the analytics mirror. */
  (function () {
    var ok = document.querySelector('[data-aj-signup-ok]');
    if (!ok) return;
    var capEl = document.querySelector('[data-aj-capture]');
    var handle = (capEl && capEl.dataset.articleHandle) || '';
    var payload = {
      aj_article: handle,
      aj_placement: ok.getAttribute('data-aj-signup-ok') || '',
      aj_country: ok.getAttribute('data-aj-country') || 'unknown'
    };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'aj_signup' }, payload));
      if (typeof window.gtag === 'function') {
        gtag('event', 'sign_up', Object.assign({ method: 'article-capture' }, payload));
      }
    } catch (e) {}
  })();

  /* ── Header cart watchdog (added 2026-08-07) ──────────────────────────────
     The header bag is intercepted by an inline handler in the layout that
     preventDefault()s and tries to open the theme drawer via ajaxCart.load().
     On the article-fast layout that never succeeds -- wpbingo.drawerCart.init()
     is not run here, so nothing responds to the `drawer.open` event -- and
     because `window.ajaxCart` DOES exist once core JS lazy-loads, that inline
     handler's own `location.href = /cart` fallback never fires either. Net
     effect before this: clicking the bag on any article did nothing at all.
     Rather than re-initialising the theme's jQuery drawer inside the fast
     layout (which exists precisely to avoid loading that bundle), this just
     watches: if no drawer actually opened shortly after the click, go to /cart.
     If the drawer is ever fixed properly, this becomes a silent no-op. */
  (function () {
    document.addEventListener('click', function (ev) {
      var link = ev.target.closest && ev.target.closest('.js-header-cart');
      if (!link) return;
      var url = link.getAttribute('href') || '/cart';
      setTimeout(function () {
        if (document.querySelector('.drawer--open')) return;   // drawer worked, leave it alone
        if (document.documentElement.classList.contains('aj-atc-sheet-open')) return;
        window.location.href = url;
      }, 1400);
    }, true);
  })();

  /* ── CRO Module D: real add-to-cart on the sticky bottom bar ───────────────
     Rebuilt 2026-08-01 (was a plain link to the PDP). Two changes from the
     design spec: (1) the button now POSTs to /cart/add.js in place, same
     handler shape as Module B's ad-slot cards; (2) the bar re-points its
     product/price/variant to whichever .aj-ad-slot card is nearest the
     viewport centre, so it follows the reader down the article instead of
     always showing the one server-rendered default -- the design asked for
     this to follow Module A's stone picker, but that module is still
     hand-authored per-article HTML with no fixed selector, so this
     generalises the same intent onto the one interactive signal every
     cro-v2 article now reliably has.
     Deliberately a scroll-driven getBoundingClientRect check, matching the
     sticky-bar-visibility logic just above in this file, rather than an
     IntersectionObserver: an IO instance set up once at page load did not
     reliably re-fire on later large/instant scroll-position jumps in this
     theme's test harness, while the existing scroll+rAF pattern already in
     this file does -- proven safer to reuse it than trust IO's timing here. */
  (function () {
    var bar = document.querySelector('[data-aj-sticky-cta]');
    if (!bar) return;
    var addBtn = bar.querySelector('[data-aj-sticky-add]');
    var titleEl = bar.querySelector('[data-aj-sticky-title]');
    var priceCurrentEl = bar.querySelector('[data-aj-sticky-price-current]');
    var compareEl = bar.querySelector('[data-aj-sticky-compare]');
    var imgEl = bar.querySelector('[data-aj-sticky-img]');
    var imgLinkEl = bar.querySelector('[data-aj-sticky-img-link]');
    var detailsEl = bar.querySelector('[data-aj-sticky-details]');
    if (!addBtn) return;

    if (document.documentElement.classList.contains('aj-cro')) {
      var slots = Array.prototype.slice.call(document.querySelectorAll('.aj-ad-slot'));
      if (slots.length) {
        var current = null;
        var repointRaf = null;
        var repointCheck = function () {
          repointRaf = null;
          var mid = window.innerHeight / 2;
          var nearest = null;
          var nearestDist = Infinity;
          slots.forEach(function (s) {
            var r = s.getBoundingClientRect();
            if (r.bottom < 0 || r.top > window.innerHeight) return; // not on screen at all
            var center = (r.top + r.bottom) / 2;
            var dist = Math.abs(center - mid);
            if (dist < nearestDist) { nearestDist = dist; nearest = s; }
          });
          if (!nearest) return;
          var slotTitleA = nearest.querySelector('.aj-ad-slot__title a');
          var slotPriceEl = nearest.querySelector('.aj-ad-slot__price');
          var slotAddBtn = nearest.querySelector('[data-aj-adslot-add]');
          if (!slotTitleA || !slotPriceEl || !slotAddBtn) return;
          var variantId = slotAddBtn.getAttribute('data-variant-id');
          if (!variantId || variantId === current) return;
          current = variantId;
          addBtn.setAttribute('data-variant-id', variantId);
          addBtn.setAttribute('data-handle', slotAddBtn.getAttribute('data-handle') || '');
          ajSetText(titleEl, slotTitleA.textContent.trim());
          // .aj-ad-slot__price is built as: optional .aj-ad-slot__compare span, then the
          // current-price text as a trailing text node -- lastChild is always that text node.
          if (priceCurrentEl) {
            var lastNode = slotPriceEl.lastChild;
            ajSetText(priceCurrentEl, lastNode ? lastNode.textContent.trim() : slotPriceEl.textContent.trim());
          }
          if (compareEl) {
            var slotCompareEl = nearest.querySelector('.aj-ad-slot__compare');
            if (slotCompareEl) {
              ajSetText(compareEl, slotCompareEl.textContent.trim());
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          var slotImg = nearest.querySelector('.aj-ad-slot__img-link img');
          if (imgEl && slotImg) {
            imgEl.src = slotImg.src;
            imgEl.alt = slotImg.alt;
            if (imgLinkEl) imgLinkEl.style.display = '';
          } else if (imgLinkEl) {
            imgLinkEl.style.display = 'none';
          }
          var href = slotTitleA.getAttribute('href');
          if (detailsEl) detailsEl.setAttribute('href', href || detailsEl.getAttribute('href'));
          if (imgLinkEl) imgLinkEl.setAttribute('href', href || imgLinkEl.getAttribute('href'));
        };
        var scheduleRepointCheck = function () {
          if (repointRaf != null) return;
          repointRaf = requestAnimationFrame(repointCheck);
        };
        window.addEventListener('scroll', scheduleRepointCheck, { passive: true });
        window.addEventListener('resize', scheduleRepointCheck, { passive: true });
        scheduleRepointCheck();
      }
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId || variantId === 'null' || variantId === '') return;
      var original = addBtn.textContent;
      addBtn.disabled = true;
      ajSetText(addBtn, 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { return Promise.reject(e); });
        return r.json();
      }).then(function (added) {
        ajSetText(addBtn, 'Added ✓');
        addBtn.classList.add('is-added');
        var item = (added && added.items && added.items[0]) || added;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            ajSetText(el, cart.item_count);
          });
          window.ajShowAtcSheet(item, cart);
        }).catch(function () { window.ajShowAtcSheet(item, null); });
        try {
          window.dataLayer = window.dataLayer || [];
          var capEl2 = document.querySelector('[data-aj-capture]');
          var handle2 = capEl2 ? capEl2.dataset.articleHandle : '';
          window.dataLayer.push({ event: 'aj_cro_click', module: 'D', variant: 'sticky-bar',
            article_handle: handle2 || '' });
          window.dataLayer.push({ event: 'aj_cart_add', module: 'D',
            product_handle: addBtn.getAttribute('data-handle') || '', article_handle: handle2 || '' });
        } catch (e) {}
        setTimeout(function () {
          addBtn.disabled = false;
          ajSetText(addBtn, original);
          addBtn.classList.remove('is-added');
        }, 2500);
      }).catch(function () {
        addBtn.disabled = false;
        ajSetText(addBtn, 'Try again');
        setTimeout(function () { ajSetText(addBtn, original); }, 2000);
      });
    });
  })();

  /* ── CRO Module C: exit-intent capture sheet ────────────────────────────────
     Gated the same broad way as the inline capture (:is(.aj-cro,.aj-cap) in
     CSS) so it reaches the sitewide aj-cap rollout, not only cro-v2 articles.
     There is no mouse-leave signal on a phone, so "exit intent" here is a
     scroll-based proxy: the reader scrolled down at least one full screen
     (they're engaged, not bouncing instantly) and then scrolled back up fast
     (heading toward the browser chrome / back button / a new tab). Gates,
     per the design spec: never within 3s of load, at most once per page
     view, and a 30-day cooldown after any dismiss or successful submit,
     stored in localStorage (not sessionStorage -- this one has to survive
     across sessions, unlike the sticky-bar dismiss). */
  (function () {
    if (!document.documentElement.classList.contains('aj-cro') &&
        !document.documentElement.classList.contains('aj-cap')) return;
    var sheet = document.querySelector('[data-aj-exit-sheet]');
    if (!sheet) return;
    var form = sheet.querySelector('.aj-exit-sheet__form');
    var COOLDOWN_MS = 30 * 24 * 60 * 60 * 1000;
    var LS_KEY = 'aj-exit-capture-suppressed-until';

    function suppressed() {
      var until = 0;
      try { until = parseInt(localStorage.getItem(LS_KEY) || '0', 10); } catch (e) {}
      return Date.now() < until;
    }
    function suppress() {
      try { localStorage.setItem(LS_KEY, String(Date.now() + COOLDOWN_MS)); } catch (e) {}
    }

    function hide() {
      sheet.classList.remove('is-visible');
      sheet.setAttribute('aria-hidden', 'true');
    }
    sheet.querySelectorAll('[data-aj-exit-dismiss]').forEach(function (el) {
      el.addEventListener('click', function () { hide(); suppress(); });
    });

    if (!suppressed()) {
      var loadTime = Date.now();
      var maxDepth = 0;
      var lastY = window.scrollY;
      var fired = false;
      var checkRaf = null;
      var check = function () {
        checkRaf = null;
        if (fired || suppressed()) return;
        if (Date.now() - loadTime < 3000) return; // never within 3s of load
        var y = window.scrollY;
        if (y > maxDepth) maxDepth = y;
        var scrolledUpFast = (lastY - y) > 150 && maxDepth > window.innerHeight;
        lastY = y;
        if (scrolledUpFast) {
          fired = true;
          sheet.classList.add('is-visible');
          sheet.setAttribute('aria-hidden', 'false');
          try {
            window.dataLayer = window.dataLayer || [];
            var capEl3 = document.querySelector('[data-aj-capture]');
            window.dataLayer.push({ event: 'aj_cro_click', module: 'C', variant: 'exit-intent-shown',
              article_handle: capEl3 ? capEl3.dataset.articleHandle : '' });
          } catch (e) {}
        }
      };
      var scheduleCheck = function () {
        if (checkRaf != null) return;
        checkRaf = requestAnimationFrame(check);
      };
      window.addEventListener('scroll', scheduleCheck, { passive: true });
    }

    if (!form) return;
    function setMsg(cls, text) {
      var old = form.querySelector('.aj-capture__ok, .aj-capture__err');
      if (old) old.remove();
      var p = document.createElement('p');
      p.className = cls;
      p.setAttribute('role', cls === 'aj-capture__ok' ? 'status' : 'alert');
      ajSetText(p, text);
      form.appendChild(p);
    }
    /* Native submit, same CAPTCHA reason as the inline capture above. */
    form.addEventListener('submit', function (ev) {
      var email = (form.querySelector('input[type=email]') || {}).value;
      if (!email) { ev.preventDefault(); setMsg('aj-capture__err', 'Please enter an email address.'); return; }
      var btn = form.querySelector('.aj-exit-sheet__submit');
      // Same reason as the inline capture: never disable the submitter mid-submit.
      if (btn) { setTimeout(function () { ajSetText(btn, 'Sending…'); }, 0); }
      var tagsInput = form.querySelector('[name="contact[tags]"]');
      var tags = tagsInput ? tagsInput.value.split(',') : ['capture:exit-intent', 'source:article'];
      var contact = { email: email, tags: tags, source: 'article-exit-intent-capture' };
      try {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['identifyContact', contact]);
        window.omnisend.push(['track', '$subscribed', { email: email }]);
      } catch (e) {}
      suppress();
      try {
        window.dataLayer = window.dataLayer || [];
        var capEl4 = document.querySelector('[data-aj-capture]');
        window.dataLayer.push({ event: 'aj_cro_click', module: 'C', variant: 'exit-intent-submit',
          article_handle: capEl4 ? capEl4.dataset.articleHandle : '' });
      } catch (e) {}
      // Falls through to the native submit (same CAPTCHA reason as above).
    }, true);
  })();
